<template>
  <div class="Scale_classification">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="background-color: #fff;padding: 14px;">
      <el-form-item label="量表代号">
        <el-input v-model="formInline.user" placeholder="量表代号"></el-input>
      </el-form-item>
      <el-form-item label="量表名称">
        <el-input v-model="formInline.region" placeholder="量表名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="Scale_classification_nav">
      <div class="Scale_classification_nav_left">
        <scales @sendmsg="getmsg"></scales>
      </div>
      <div class="Scale_classification_nav_right">
        <el-button type="primary" style="margin-left: 1%;margin-top: 14px;" @click="addfun('',1)">新增</el-button>
        <el-table :data="tableData" style="width: 98%;margin-left: 1%;margin-top: 14px;">
          <el-table-column prop="paperName" label="量表名称" width="180"></el-table-column>
          <el-table-column prop="paperCode" label="量表代号" width="180"></el-table-column>
          <el-table-column prop="hasFactor" label="有因子否">
            <template slot-scope="scope">
              <span>{{scope.row.hasFactor==1?'有':'无'}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="IsMissQuestion" label="允许漏题">
            <template slot-scope="scope">
              <span>{{scope.row.IsMissQuestion == 1?'允许':'不允许'}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="lineNumber" label="排序"></el-table-column>

          <el-table-column prop="isactive" label="是否启用">
            <template slot-scope="scope">
              <span>{{scope.row.isactive==1?'是':'否'}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="CreatedDate" label="创建时间"></el-table-column>
          <!-- <el-table-column prop="address" label="推荐到首页"></el-table-column>
          <el-table-column prop="address" label="推荐到测试页"></el-table-column> -->

          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span class="w" @click="addfun(scope,2)">修改</span>
            </template>
          </el-table-column>
          
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>

      </div>
      
    </div>
  </div>
  
</template>
<script>
  import scales from '@/components/scales.vue'
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: '',
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: [],
        paperCode:'',
        Counts:0,
        pageNum:1,
      };
    },
    components:{
      scales
    },
    methods: {
      handleCurrentChange(val) {
        this.pageNum = val;
        this.xaxa();
      },
      getmsg(val){//量表点击时子组件传过来值
        this.pageNum = '1';
        this.paperCode = val;
        this.xaxa();
      },
      xaxa(){
        this.$Http_Post('/paperconfig/papercfg/list', {ppaperCode:this.paperCode,pageNum:this.pageNum,pageSize:'10'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Counts = res.Counts;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      addfun(id,val) {
        if(val == '1'){
          this.$router.push({path: '/Scale/Add_scale'});
        }else{
          this.$router.push({path: '/Scale/Add_scale',query: {paperCode: id.row.paperCode}});
        }
      },
      onSubmit1() {
        this.$router.push({path: '/Scale/Scale_instruction'})
      },
      onSubmit() {
        console.log('submit!');
      },
      handleNodeClick(data) {
        console.log(data);
      }
    }
  };
</script>
<style>
.Scale_classification{width: 100%;height: 100%;}
.Scale_classification_nav{width: 100%;height: calc(100% - 104px);margin-top: 14px;}
.Scale_classification_nav_left{width: 450px;height: 100%;overflow: auto;float: left;background-color: #fff;}
.Scale_classification_nav_right{width: calc(100% - 464px);height: 100%;float: right;background-color: #fff;}
</style>